import {enableProdMode,} from '@angular/core';
import {platformBrowserDynamic,} from '@angular/platform-browser-dynamic';

import {AppModule,} from 'app/app.module';
import {environment,} from '@environments/environment';
import {EnvironmentType,} from '@models/system-vo/environment-type';

if (environment.type === EnvironmentType.PROD) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch((err) => {
    console.error(err);
  });

